<template>
    <div class="node-properties-inner">
        <select v-model="properties.geometry">
            <option value="triangle">Triangle</option>
            <option value="rectangle">Rectangle</option>
            <option value="square">Square</option>
        </select>
    </div>
</template>

<script>
export default {
    props: {
        properties: { type: Object, required: true }
    }
}
</script>
